import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, LanguageService, TranslationService } from '@spartacus/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { Subscription, combineLatest, distinctUntilChanged, shareReplay } from 'rxjs';
import { OrderStatusService } from 'src/app/services/feature/orderStatus/order-status.service';
import moment from 'moment';
@Component({
  selector: 'app-order-status-list',
  templateUrl: './order-status-list.component.html',
  styleUrls: ['./order-status-list.component.scss'],
  standalone: false
})
export class OrderStatusListComponent {
  orderStatusList$ = this.orderStatusService.getOrderStatusList().pipe(shareReplay(1));
  coWorker: boolean = false;
  today: Date = new Date();
  submitted = false;
  searchDataList: any;
  totalResults: any;
  pageItems: any;
  orderStatusData: any;
  bsConfigFormat: string = 'DD.MM.YYYY';
  openPositionData: any;
  canLoadPage: boolean = false;
  orderStatusForm = new FormGroup(
    {
      poNumber: new FormControl(''),
      orderStatus: new FormControl(null),
      orderNumber: new FormControl(''),
      cpn: new FormControl(''),
      customerId: new FormControl(null),
      orderDateFrom: new FormControl(null, [Validators.required]),
      orderDateTo: new FormControl(new Date(), [Validators.required]),
      showCoworkersOrder: new FormControl(false)
    }
  );
  sortCategory = false;
  sortCategoryDesc = false;

  sortDate = false;
  sortDateDesc = false;

  sortCustomer = false;
  sortCustomerDesc = false;

  sortCode = false;
  sortCodeDesc = false;

  sortPO = false;
  sortPODesc = false;

  sortStatus = false;
  sortStatusDesc = false;

  sortOrderType = false;
  sortOrderTypeDesc = false;
  private previousDatepicker: BsDatepickerDirective | null = null;
  subscription = new Subscription();
  constructor(private orderStatusService: OrderStatusService,
    private cdr: ChangeDetectorRef, private translateService: TranslationService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private langService: LanguageService) {

  }

  openDatepicker(datepicker: BsDatepickerDirective) {
    if (this.previousDatepicker && this.previousDatepicker !== datepicker) {
      this.previousDatepicker.hide();
    }
    this.previousDatepicker = datepicker;
  }

  ngOnInit() {
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(new Date().getDate() - 7);
    this.orderStatusForm.controls['orderDateFrom'].setValue(oneWeekAgo);
    this.subscription.add(this.orderStatusList$.subscribe((res: any) => {
      this.openPositionData = res;
      this.bsConfigFormat = this.openPositionData.dateFormat.toUpperCase();
      this.orderStatusForm.controls['showCoworkersOrder'].setValue(res?.showCoworkersOrder);
      this.orderStatusData = res;
      this.orderStatusForm.controls['customerId'].setValue(res.currentB2BUnitWS.uid);
      const data = this.orderStatusService.getSearchData();
      if (data) {
        this.orderStatusForm.controls['orderDateFrom'].setValue(data.startDate);
        this.orderStatusForm.controls['orderDateTo'].setValue(data.endDate);
        this.orderStatusForm.controls['poNumber'].setValue(data.poNumber);
        this.orderStatusForm.controls['orderStatus'].setValue(data.orderStatus);
        this.orderStatusForm.controls['orderNumber'].setValue(data.orderNo);
        this.orderStatusForm.controls['cpn'].setValue(data.partNo);
        this.orderStatusForm.controls['showCoworkersOrder'].setValue(data.showCoworkersOrder);

      }
      this.canLoadPage = true;
      this.search();
    }));
  this.subscription.add(this.langService
       .getActive().pipe(distinctUntilChanged())
       .subscribe((langChange) => {
      //   // this.orderStatusList$.subscribe((res: any) => {
      //   //   this.orderStatusData = res;
      //   //   this.cdr.detectChanges();
      //   // })
    //  // this.search();
       }));
  }

  reset() {
    const exclude: string[] = ['customerId'];
    Object.keys(this.orderStatusForm.controls).forEach(key => {
      if (exclude.findIndex(q => q === key) === -1) {
        this.orderStatusForm.get(key).reset();
      }
    });
  }

  search(currentPage?, sort?) {
    this.submitted = true;
    if (!this.orderStatusForm.controls['orderDateFrom'].value) {
      // Set error and mark the field as touched
      this.orderStatusForm.controls['orderDateFrom'].setErrors({ required: true });
      this.orderStatusForm.controls['orderDateFrom'].markAsTouched();
    }

    if (!this.orderStatusForm.controls['orderDateTo'].value) {
      // Set error and mark the field as touched
      this.orderStatusForm.controls['orderDateTo'].setErrors({ required: true });
      this.orderStatusForm.controls['orderDateTo'].markAsTouched();
    }

    if (this.orderStatusForm.invalid) {
      // Prevent form submission if the form is invalid
      return;
    }
    if (this.orderStatusForm.valid) {
      if (this.getDaysDifference(this.orderStatusForm.controls['orderDateFrom'].value, this.orderStatusForm.controls['orderDateTo'].value) > 365) {
        this.globalMessageService.add(
          { key: 'common.text_dates_difference_error' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      } else {
        const payload = {
          "defaultSoldTo": this.orderStatusForm.controls['customerId'].value,
          "startDate": this.orderStatusForm.controls['orderDateFrom'].value,
          "endDate": this.orderStatusForm.controls['orderDateTo'].value,
          "poNumber": this.orderStatusForm.controls['poNumber'].value?.trim(),
          "orderStatus": this.orderStatusForm.controls['orderStatus'].value,
          "orderNo": this.orderStatusForm.controls['orderNumber'].value?.trim(),
          "partNo": this.orderStatusForm.controls['cpn'].value?.trim(),
          "showCoworkersOrder": this.orderStatusForm.controls['showCoworkersOrder'].value ?? false
        }
        this.orderStatusService.setSearchData(payload);
        this.subscription.add(this.orderStatusService.search(payload, currentPage, sort).subscribe((data: any) => {
          if (data) {
            this.searchDataList = data;
            this.cdr.detectChanges();
            this.subscription.add(combineLatest([
              this.translateService.translate('common.text_account_orderHistory_page_totalResults'), this.translateService.translate('common.text_account_core_search_totalResultsCurrPage')
            ]).subscribe(([res1, res2]: any) => {
              this.totalResults = res1.replace('{0}', data.pagination?.totalResults);

              if (data.pagination?.currentPage == 0) {
                this.pageItems = res2.replace('{1}', data.pagination?.totalResults).replace('{0}', (data.pagination?.pageSize * data.pagination?.currentPage) + 1 + '-' + (data.pagination.totalPages == 1 ? data.pagination.totalResults : data.pagination?.pageSize * (data.pagination?.currentPage + 1)))
              } else if (data.pagination?.currentPage > 0) {
                this.pageItems = res2.replace('{1}', data.pagination?.totalResults).replace('{0}', (data.pagination?.pageSize * data.pagination?.currentPage) + 1 + '-' + ((data.pagination.currentPage + 1) == data.pagination.totalPages ? data.pagination.totalResults : data.pagination?.pageSize * (data.pagination?.currentPage + 1)));
              }
              this.cdr.detectChanges();
            }));
          }
        }));
      }
    }
  }

  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);

    return moment(date).format(format.toUpperCase());
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

  changePageCustom(e, data) {
    this.search(e);
  }

  openNewTab(item) {
    const formattedRoute = item.code + '-' + item.unit.uid + '-' + item.placedFormat;
    return formattedRoute;
  }

  redirectOrder(item) {
    const formattedRoute = item.code + '-' + item.unit.uid + '-' + item.placedFormat;
    this.router.navigate(['order'], {
      queryParams: { orderId: formattedRoute },
    });
  }
  sort(type) {
    if (type === 'byCategory') {
      this.sortByCategory();

    } else if (type === 'byDate') {
      this.sortByDate();

    } else if (type === 'byCode') {
      this.sortByCode();
    }
    else if (type === 'byPO') {
      this.sortByPo();
    }
    else if (type === 'byOrderType') {
      this.sortByOrderType();
    }
    else if (type === 'byCustomer') {
      this.sortByCustomer();
    } else if (type === 'byStatus') {
      this.sortStatus = !this.sortStatus;
      const sort = this.sortStatus ? 'byStatus' : 'byStatusDesc';
      this.search(0, sort);
    }
  }

  sortByCategory() {
    this.sortCategory = !this.sortCategory;
    const sort = this.sortCategory ? 'byCategory' : 'byCategoryDesc'
    this.search(0, sort);
  }

  sortByDate() {
    this.sortDate = !this.sortDate;
    const sort = this.sortDate ? 'byDate' : 'byDateDesc';
    this.search(0, sort);
  }

  sortByCode() {
    this.sortCode = !this.sortCode;
    const sort = this.sortCode ? 'byCode' : 'byCodeDesc';
    this.search(0, sort);
  }

  sortByPo() {
    this.sortPO = !this.sortPO;
    const sort = this.sortPO ? 'byPO' : 'byPODesc';
    this.search(0, sort);
  }

  sortByOrderType() {
    this.sortOrderType = !this.sortOrderType;
    const sort = this.sortOrderType ? 'byOrderType' : 'byOrderTypeDesc';
    this.search(0, sort);
  }

  sortByCustomer() {
    this.sortCustomer = !this.sortCustomer;
    const sort = this.sortCustomer ? 'byCustomer' : 'byCustomerDesc';
    this.search(0, sort);
  }

  getDaysDifference(date1, date2) {
    const startDate: any = new Date(date1);
    const endDate: any = new Date(date2);
    const differenceInTime: any = endDate - startDate;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
